import writeXlsxFile from 'write-excel-file/browser';

export async function downloadXlsx(data, fileName) {
    const headers = Object.keys(data[0] ?? {});
    const sheetData = [
        headers,
        ...data.map((row) => headers.map((key) => row[key] ?? '')),
    ];
    await writeXlsxFile(sheetData).toFile(fileName);
}
